import { COLLECTIONS, STATUSES } from '__constants__'

import { useCollection } from 'services/api/firebase'
import { useGetQuery } from 'hooks'

/**
 * It returns an array of values that are used to render the newspapers
 * @param props - An object that contains the query parameters.
 * @returns An array of values.
 */

const useGetNewspapers = (props) => {
  /* Query for getting collection reference */
  const query = useGetQuery({
    collectionName: COLLECTIONS.NEWSPAPERS,
    where: props?.where,
    orderBy: props?.orderBy,
    statuses: STATUSES.NEWSPAPER_STATUSES,
    fieldName: '_id'
  })

  /* Getting collection data */
  return useCollection(query)
}

export default useGetNewspapers
